import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Form Loader",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-form-loader",
    args: {
        buttonsToDisable: "null",
        loaderInsertPosition: "beforebegin",
        loaderMarginOffset: 0,
        loaderTarget: "",
    },
    argTypes: {
        buttonsToDisable: { control: "text" },
        loaderInsertPosition: {
            control: { type: "select" },
            options: ["afterbegin", "afterend", "beforebegin", "beforeend"],
        },
        loaderMarginOffset: { control: "number" },
        loaderTarget: { control: "text" },
    },
};

const Template = ({ loaderMarginOffset, loaderTarget }) =>
    html`<ux-form>
            <form action="#">
                <h2>Form wrapped by ux-form</h2>
                <div class="ux-u-mb-xxs">
                    <ux-input-field
                        required
                        name="tx_form_formframework[kontaktformular-618471][firstname]"
                        label="name"
                    ></ux-input-field>
                </div>
                <ux-iws-form-loader
                    loader-target="${loaderTarget}"
                    loader-margin-offset="${loaderMarginOffset}"
                ></ux-iws-form-loader>
                <div class="ux-u-mb-xs">
                    <ux-input-field
                        required
                        name="tx_form_formframework[kontaktformular-618471][lastname]"
                        label="surname"
                    ></ux-input-field>
                </div>
                <div>
                    <button class="ux-button ux-button--green" type="submit">
                        Submit
                    </button>
                    <button class="ux-button" type="submit">Go Back</button>
                </div>
            </form>
        </ux-form>
        <form
            action="https://trumpf.com.cms.qa.tru/de_INT/testp-form/?no_cache=1&tx_form_formframework%5Baction%5D=perform&tx_form_formframework%5Bcontroller%5D=FormFrontend&cHash=e8e63832581ad51e10e9492b6d78a494#kontaktformular-618471"
        >
            <h2>Form without ux-form</h2>
            <div class="ux-u-mb-xxs">
                <ux-input-field
                    required
                    name="tx_form_formframework[kontaktformular-618471][firstname]"
                    label="name"
                ></ux-input-field>
            </div>
            <ux-iws-form-loader
                loader-target="${loaderTarget}"
                loader-margin-offset="${loaderMarginOffset}"
            ></ux-iws-form-loader>
            <div class="ux-u-mb-xs">
                <ux-input-field
                    required
                    name="tx_form_formframework[kontaktformular-618471][lastname]"
                    label="surname"
                ></ux-input-field>
            </div>
            <div>
                <button class="ux-button ux-button--green" type="submit">
                    Submit
                </button>
                <button class="ux-button" type="submit">Go Back</button>
            </div>
        </form>`;

export const Default = Template.bind({});
Default.args = {
    loaderMarginOffset: 15,
    loaderTarget: ".ux-button",
};
